<style lang="scss" scoped>
.classes {
	& ::v-deep .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
			> div {
				margin-right: 15px;
				font-size: 100%;
			}
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	.toggleButton {
		margin-right: 10px;
	}
	&__table {
		border-collapse: collapse;
		td,
		th {
			&:first-child {
				padding-left: 40px !important;
			}
			&:last-child {
				padding-right: 40px;
			}
		}
		td.-item {
			cursor: pointer;
		}
		tr.hover:hover {
			background-color: #D6D6D6;
			cursor: pointer;
		}
		&__missing-item {
			display: inline-block;
			padding-left: 10px;
			color: red;
			font-size: 16px;
			vertical-align: middle;
		}
	}
}
.toggle-button {
	margin-right: 15px;
}
</style>
<template lang="pug">
.classes
	app-header
		.classes__header(slot='header')
			h1 {{ activeUser ? `${activeUser.first_name} ${activeUser.last_name} Classes` : 'Match classes' }}
			.classes__header__options
				auto-enable-classes-button.toggle-button(v-if="!activeUser", buttonLabel="automated classes sync", @auto-sync-classes-change="refetchMathedClasses")
				el-dropdown(@command="saveByBatch").ml-auto
					el-button(type="primary", :disabled="inputClasses.length < 1", :loading="saveLoading") {{ actionText }} {{ inputClasses.length > 0 ? inputClasses.length : '' }} selected
						i(class="el-icon-arrow-down el-icon--right")
					el-dropdown-menu(slot="dropdown")
						template(v-if="activeUser")
							el-dropdown-item(command="add") Add user to class{{ inputClasses.length > 1 ? 'es' : '' }}
							el-dropdown-item(command="remove") Remove user from class{{ inputClasses.length > 1 ? 'es' : '' }}
						template(v-else)
							el-dropdown-item(:command="null") Sync class{{ inputClasses.length > 1 ? 'es' : '' }}
							el-dropdown-item(command="ignore") Ignore class{{ inputClasses.length > 1 ? 'es' : '' }}
	.classes__container
		.classes__panel
			loading(v-if="$apollo.loading || saveLoading")
			template(v-else)
				result-filter.ml-auto.mr-2(v-model="filters" :filter-fields='fields', :remember="false")
				table.table.classes__table
					thead
						tr
							th(width="80")
								input(v-model='checkAll', type='checkbox')
							th Edusync class
							th Code
							th Type
							th
								template(v-if="activeUser") Instructor?
								template(v-else) Instructor(s)
							th Status
					tbody
						tr.hover(v-for='(row, index) in paginated', :key='index')
							td
								input(v-model='row.selected', type='checkbox')
							td(@click='rowClicked(row)') {{ row.name }}
							td(@click='rowClicked(row)') {{ row.code }}
							td(@click='rowClicked(row)') {{ row.type | capitalize }}
							td(@click='rowClicked(row)') 
								template(v-if="activeUser") {{ activeUserClasses.includes(row.id) ? 'Yes' : 'No' }}
								template(v-else) {{ row.Teachers.length }}
							td(@click='rowClicked(row)') {{ row.assigned === "" || row.assigned === null ? "sync" : row.assigned | capitalize }}
				.classes__footer
					.classes__footer__left
						el-pagination(background='', layout='prev, pager, next', :current-page.sync='page', :page-size='per_page', :total='filtered.length')
					.classes__footer__right(v-if="paginated && filtered")
						| Showing
						strong &nbsp;{{ paginated.length }}
						| &nbsp;out of a possible
						strong &nbsp;{{ filtered.length }}
						| &nbsp;results
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import Fuse from "fuse.js";
import Bugsnag from "@bugsnag/js";
import AutoEnableClassesButton from "../../includes/AutoEnableClassesButton.vue";
export default {
	components: {
		AutoEnableClassesButton
	},
	watch: {
		checkAll(val) {
			_.each(this.filtered, r => {
				this.$set(r, "selected", val)
			});
		}
	},
	data() {
		return {
			filters: null,
			archiveLoading: false,
			saveLoading: false,
			refetchingClasses: false,
			page: 1,
			per_page: 50,
			optionLimit: 20,
			fields: [
				{
					name: "Name",
					path: "name",
					type: "text"
				},
				{
					name: "Type",
					path: "type",
					type: "radio",
					options: [
						{
							label: "Class",
							value: "class"
						},
						{
							label: "Registration",
							value: "registration"
						}
					]
				},
				{
					name: "Status",
					path: "status",
					type: "radio",
					options: [
						{
							label: "Sync",
							value: "sync"
						},
						{
							label: "Ignore",
							value: "ignore"
						}
					]
				}
			],
			allowedMultipleMatches: ["ignore"],
			checkAll: false,
		};
	},
	computed: {
		saveButtonType() {
			return "primary";
		},

		actionText() {
			return this.saveLoading ? "Actioning" : "Action";
		},

		selected() {
			return _.filter(this.filtered, { selected: true });
		},

		inputClasses() {
			return _(this.filtered)
				.filter((cls) => {
					return cls.selected;
				})
				.map((cls) => {
					return {
						wondeId: cls.id,
						wondeIdType: cls.type,
						providerId: cls.assigned
					};
				})
				.value();
		},

		filtered() {
			let filtered = _.map(this.classes, row => {
				const foundRecord = _.find(this.matchedClasses, { wondeId: row.id, wondeIdType: row.type });
				if (foundRecord) {
					row.assigned = foundRecord.providerId;
					row.status = foundRecord.status;
					if (foundRecord.status === "ignored") {
						row.assigned = "ignore";
					}
				} else {
					row.assigned = "ignore";
				}
				return row;
			});

			if (this.classes && this.filters) {
				if (this.filters.name) {
					filtered = _.filter(filtered, row => {
						return this.filters.name.filter_type == 'starts_with' ? _.startsWith(row.name.toLowerCase(), this.filters.name.value.toLowerCase()) : row.name.toLowerCase().includes(this.filters.name.value.toLowerCase());
					});
				}
				if (this.filters.type) {
					filtered = _.filter(filtered, { type: this.filters.type.value });
				}
				if (this.filters.status) {
					const assigned = this.filters.status.value === "sync" ? "" : this.filters.status.value;
					filtered = _.filter(filtered, { assigned });
				}
			}
			return filtered;
		},

		paginated() {
			return _.chunk(this.filtered, this.per_page)[this.page - 1];
		},

		activeUser() {
			if (!_.isEmpty(this.directory)) {
				return _.find(this.directory.WondeUsers, { id: this.$route.params.id })
			}
            
			return null;
        },
		
		activeUserClasses() {
			if (_.isEmpty(this.activeUser)) return [];
			let classes = [];

			_.map(this.classes, (cls) => {
				if (_.find(cls.Teachers, { id: this.activeUser.id })) {
					classes.push(cls.id);
				}
			});

			return classes;
		}
	},
	methods: {
		async saveMatches(inputClasses) {
			console.log(inputClasses)
			this.saveLoading = true;
			try {
				if (this.activeUser) {
					await this.$apollo.mutate({
						mutation: gql`
							mutation ClassMembersOverride($classMembersOverride: [ClassMembersOverrideInput!]!) {
								ClassMembersOverride(classMembersOverride: $classMembersOverride) {
									wondeId
									wondeIdType
									memberId
								}
							}
						`,
						variables: {
							classMembersOverride: _.map(inputClasses, (cls) => {
								return {
									wondeId: cls.wondeId,
									wondeIdType: cls.wondeIdType,
									memberId: this.activeUser.id,
									memberIdType: "employee",
									action: cls.providerId,
								};
							})
						}
					});
				} else {
					await this.$apollo.mutate({
						mutation: gql`
							mutation MatchClasses($input: [MatchClassInput!]!) {
								MatchClasses(input: $input) {
									id
									providerId
									wondeId
									wondeIdType
								}
							}
						`,
						variables: {
							input: inputClasses
						}
					});
				}
				
			} catch (error) {
				Bugsnag.notify(JSON.stringify(error, null, 2));
				this.$message.error("Failed to save matches");
			}
		},

		async saveByBatch(val) {
			this.saveLoading = true;
			// Archiving more than 6 classes is timing out for some schools
			const perPage = 6;
			let curPage = 1;
			let promises = [];
			let chunk = _.chunk(this.inputClasses, perPage)[curPage - 1];
			
			while(chunk) {
				chunk = _.map(chunk, (cls) => {
					cls.providerId = val;

					return cls;
				});
				
				promises.push(this.saveMatches(chunk));
				curPage++;
				chunk = _.chunk(this.inputClasses, perPage)[curPage - 1];
			}

			await Promise.all(promises);
			await this.$apollo.queries.matchedClasses.refetch();
			await this.$apollo.queries.classes.refetch();
			this.$message.success(`Class matches saved successfully`);
			this.checkAll = false;
			this.saveLoading = false;
		},

		rowClicked(row) {
			this.$router.push({ name: "instructors", params: {id: row.id}})
		},
		refetchMathedClasses() {
			this.$apollo.queries.matchedClasses.refetch();
		}
	},

	apollo: {
		matchedClasses: {
			query: gql`
				{
					MatchedClasses {
						id
						status
						providerId
						wondeId
						wondeIdType
						providerName
					}
				}
			`,
			fetchPolicy: "no-cache",
			update: r => r.MatchedClasses
		},
		classes: {
			query: gql`
				{
					Classes {
						id
						name
						type
						code
						Teachers {
							id
						}
					}
				}
			`,
			fetchPolicy: "no-cache",
			update: r =>
				_(r.Classes)
					.map(cls => ({
						...cls,
						assigned: null
					}))
					.sortBy("name")
					.value()
		},
		directory: {
			query: gql`
				{
					Directory {
						id
						WondeUsers {
							id
							mis_id
							base_type
							first_name
							last_name
							date_of_birth
							email
							status
							missing
							matched_id
							matched_name
							assign
							assigning
							selected
							groups
							primary_location
							grace_at
							CustomFields {
								person_id {
									format
									value
								}
							}
							age_group
							consent_provided_for_minor
						}
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r => r.Directory,
		},
	}
};
</script>
